const ThemeConstants = {
  primaryColor: '#09abee',
  primaryColorLight: '#ffffff',
  secondaryColor: '#000000',
  headingFont: "'Poppins', sans-serif",
}

export default ThemeConstants
